import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { useCloseModal } from '@/hooks/useCloseModal';

type Props = {
  onImport: () => void;
  onBlur?: () => void;
  subtitle?: string;
  warning?: React.ReactNode;
};

function ModalImport({ onImport, onBlur, subtitle, warning }: Props) {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);
  const closeModal = useCloseModal();

  const handleImport = () => {
    onImport();
    closeModal();
  };

  const handleCancel = () => {
    onBlur?.();
    closeModal();
  };

  return (
    <Dialog open onOpenChange={(open) => !open && handleCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('prompts.unsaved_changes.title')}</DialogTitle>
          {subtitle && <DialogDescription>{subtitle}</DialogDescription>}
        </DialogHeader>
        {warning}
        <div className="mt-2 flex items-center gap-2">
          <Checkbox
            id="import-checkbox"
            checked={checked}
            onCheckedChange={(value) => setChecked(value === true)}
            name="checkbox"
          />
          <Label htmlFor="import-checkbox" className="cursor-pointer">
            {t('dialog.import_dialog_ok')}
          </Label>
        </div>
        <DialogFooter>
          <Button variant="ghost-neutral" onClick={handleCancel}>
            {t('common.cancel')}
          </Button>
          <Button variant="destructive" onClick={handleImport} disabled={!checked}>
            {t('common.import_anyway')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ModalImport;
